// extracted by mini-css-extract-plugin
module.exports = {"palyerRatingFooter":"PlayersRatingTable_palyerRatingFooter_1JlEF"};